import { useState } from "react";
import { faqs } from "@/mocks/feed";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-question-answer-line" aria-hidden="true"></i> 常见问题
          </p>
          <h2 className="font-display mt-3 text-2xl md:text-4xl text-foreground-950">关于吃瓜网上，你可能想问</h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-600">一些常见疑问，希望这里的回答能帮到你。</p>
        </div>

        <div className="mt-8 divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100 overflow-hidden">
          {faqs.map((item, i) => {
            const open = openIdx === i;
            return (
              <div key={item.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base font-medium text-foreground-900">
                      <span className="mr-2 text-primary-600 font-display">Q{i + 1}</span>
                      {item.q}
                    </span>
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"}`}>
                      <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-base`} aria-hidden="true"></i>
                    </span>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-5">
                    <p className="pl-0 md:pl-8 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}